import { map, pick, get, partial, filter } from 'lodash';
import { CHANNEL_TYPES } from '@wix/wix-vod-constants/common';
import { createSelector } from 'reselect';
const isInternalChannel = channel => channel.channelType === CHANNEL_TYPES.CHANNEL;
export const filterInternalChannels = channels => filter(channels, isInternalChannel);
export function getChannelIds(state) {
  return state.channels.ids;
}
export function getChannelById(state, channelId) {
  return state.entities.channels[channelId];
}
export function isFetchingChannels(state) {
  return state.channels.activeRequests !== 0;
}

/**
 * @param state
 * @returns {Object[]} channels list
 */
export const getChannels = createSelector([state => state, getChannelIds], (state, ids) => map(ids, partial(getChannelById, state)));
export const getChannelsInternal = createSelector(getChannels, filterInternalChannels);
export const getAllChannelsGroupedByIds = state => state.entities.channels;

/**
 * @param state
 * @returns {Object} {id: channel}
 */
export const getChannelsGroupedByIds = createSelector([getAllChannelsGroupedByIds, getChannelIds], pick);

/**
 * @param state
 * @returns {Object} channel
 */
export const getChannelForWidget = createSelector([_ref => {
  let {
    channelInfo
  } = _ref;
  return get(channelInfo, 'info');
}, _ref2 => {
  let {
    channelInfo
  } = _ref2;
  return get(channelInfo, 'paymentInfo');
}], (info, paymentInfo) => {
  if (!info && !paymentInfo) {
    return null;
  }
  return {
    ...info,
    ...paymentInfo
  };
});
//# sourceMappingURL=channels.js.map